import ListSales from "./ListSales";

export default function AuditSales() {
  return <ListSales mode="audit" />;
}